/* eslint max-len: ["error", { "code": 120, "tabWidth": 4 }] */
/* eslint-disable node/no-unsupported-features */
import * as types from '../constants/ActionTypes';

export default (state = {isFetching: false,
                         error: false,
                         errorCode: 0,
                         calcOk: false,
                         sex: '',
                         age: 0,
                         length: 0,
                         lengthMean: 0,
                         ageMean: 0,
                         telomereMLLength: 0,
                         lengthDev: 0,
                         devWarning: false,
                         suggestedAge: 0,
                         averageLengthForAge: 0,
                         algoG: 0,
                         telomereMLAge: 0,
                         labAge: 0,
                         urlGraph: ''}, action) => {
    switch (action.type) {
        case types.REQUEST_TELOMERE:
            return {
                ...state,
                error: false,
                errorCode: 0,
                isFetching: true,
                calcOk: false,
            };
        case types.RECEIVE_TELOMERE:
            return {
                ...state,
                error: false,
                errorCode: 0,
                isFetching: false,
                calcOk: true,
                sex: action.telomere.sex,
                age: action.telomere.age,
                length: action.telomere.length,
                lengthMean: action.telomere.lengthMean,
                ageMean: action.telomere.ageMean,
                telomereMLLength: action.telomere.telomereMLLength,
                lengthDev: action.telomere.lengthDev,
                devWarning: action.telomere.devWarning,
                suggestedAge: action.telomere.suggestedAge,
                averageLengthForAge: action.telomere.averageLengthForAge,
                algoG: action.telomere.algoG,
                telomereMLAge: action.telomere.telomereMLAge,
                labAge: action.telomere.labAge,
                urlGraph: action.telomere.urlGraph,
            };
        case types.ERROR_TELOMERE:
            return {
                ...state,
                error: true,
                errorCode: action.errorCode,
                isFetching: false,
                calcOk: false,
            };
        case types.RESET_ERROR_TELOMERE:
            return {
                ...state,
                error: false,
                errorCode: 0,
                calcOk: false,
                isFetching: false,
                sex: '',
                age: 0,
                length: 0,
                lengthMean: 0,
                ageMean: 0,
                telomereMLLength: 0,
                lengthDev: 0,
                devWarning: false,
                suggestedAge: 0,
                averageLengthForAge: 0,
                algoG: 0,
                telomereMLAge: 0,
                labAge: 0,
                urlGraph: '',
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/telomere.js